import { render, staticRenderFns } from "./CheatNotice.vue?vue&type=template&id=48596ca0&scoped=true"
import script from "./CheatNotice.vue?vue&type=script&lang=js"
export * from "./CheatNotice.vue?vue&type=script&lang=js"
import style0 from "./CheatNotice.vue?vue&type=style&index=0&id=48596ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48596ca0",
  null
  
)

export default component.exports